import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import AddSubContest from "./AddUpdate";
import { Link } from "react-router-dom";
import "../../css/style.css";

class DataManagement extends Component {
  state = {
    DataList: [],
    pageNo: 1,
    length: 0,
    newName: "",
    newImage: null,
    newMobileImageFile: null,
    newMobileImageUrl: "",
    showPopup: false,
    showAddSubContestPopup: false,
    editingItem: null,
    isEditMode: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  toggleAddSubContestPopup = () => {
    this.setState((prevState) => ({
      showAddSubContestPopup: !prevState.showAddSubContestPopup,
    }));

    this.props.history.push("/add-sub-contest");
  };

  handleEdit = (item) => {
    this.setState({
      editingItem: item,
      isEditMode: true,
      showPopup: true,
      newName: item.name,
    });
  };

  handleImageChange = (e) => {
    this.setState({
      newImage: e.target.files[0],
    });
  };

  handleMobileImageChange = async (e) => {
    try {
      const file = e.target.files[0];
      this.setState({ newMobileImageFile: file });
      if (!file) return;
      const token = getAccessToken();
      const fd = new FormData();
      fd.append("mobileImage", file);
      const resp = await Axios.post(
        Constant.apiBasePath + "openMic/upload-mobile-image",
        fd,
        {
          headers: { token, "Content-Type": "multipart/form-data" },
        }
      );
      if (resp.data && resp.data.status === "Success" && resp.data.url) {
        this.setState({ newMobileImageUrl: resp.data.url });
      }
    } catch (err) {
      console.error("Error uploading mobile image:", err);
    }
  };

  fetchData = async () => {
    try {
      let token = getAccessToken();
      const response = await Axios.post(
        Constant.apiBasePath + "openMic/get-all",
        {},
        { headers: { token: token } }
      );
      let { data } = response;
      if (data.status === "Success") {
        this.setState({
          DataList: data.data,
          pageNo: data.pageNo,
          length: data.length,
        });
      } else {
        console.error("Failed to fetch data:", data.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  togglePopup = () => {
    this.setState({
      showPopup: !this.state.showPopup,
      isEditMode: false,
      editingItem: null,
      newName: "",
      newImage: null,
    });
  };

  handleInputChange = (e) => {
    this.setState({
      newName: e.target.value,
    });
  };

  addNewItem = async () => {
    try {
      const { newName, newImage, newMobileImageUrl } = this.state;
      let token = getAccessToken();

      const form_data = new FormData();
      form_data.append("name", newName);
      if (newImage) {
        form_data.append("openMicImage", newImage);
      }
      if (newMobileImageUrl) {
        form_data.append("mobileImage", newMobileImageUrl);
      }

      const response = await Axios.post(
        Constant.apiBasePath + "openMic/create",
        form_data,
        {
          headers: {
            token: token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      let { data } = response;
      if (data.status === "Success") {
        await this.fetchData();
        this.setState({
          newName: "",
          newImage: null,
          newMobileImageFile: null,
          newMobileImageUrl: "",
          showPopup: false,
        });
      } else {
        console.error("Failed to add new item:", data.message);
      }
    } catch (error) {
      console.error("Error adding new item:", error);
    }
  };

  editItem = async () => {
    try {
      const { newName, newImage, newMobileImageUrl, editingItem } = this.state;
      let token = getAccessToken();

      const form_data = new FormData();
      form_data.append("name", newName);
      if (newImage) {
        form_data.append("openMicImage", newImage);
      }
      if (newMobileImageUrl) {
        form_data.append("mobileImage", newMobileImageUrl);
      }

      const response = await Axios.patch(
        Constant.apiBasePath + `openMic/editContestName/${editingItem._id}`,
        form_data,
        {
          headers: {
            token: token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      let { data } = response;
      if (data.status === "Success") {
        await this.fetchData();
        this.setState({
          newName: "",
          newImage: null,
          newMobileImageFile: null,
          newMobileImageUrl: "",
          showPopup: false,
          isEditMode: false,
          editingItem: null,
        });
      } else {
        console.error("Failed to edit item:", data.message);
      }
    } catch (error) {
      console.error("Error editing item:", error);
    }
  };

  deleteItem = async (itemId) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        `${Constant.apiBasePath}openMic/${itemId}`,
        { headers: { token: token } }
      );
      const { data } = response;
      if (data.status === "Success") {
        this.setState((prevState) => ({
          DataList: prevState.DataList.filter((item) => item._id !== itemId),
        }));
        alert("Item deleted successfully");
      } else {
        console.error("Failed to delete item:", data.message);
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  changeStatus = async (id, status) => {
    try {
      let token = getAccessToken();
      const response = await Axios.patch(
        Constant.apiBasePath + "openMic/changeStatus/" + id,
        { status: status },
        { headers: { token: token } }
      );
      const { data } = response;
      if (data.status === "Success") {
        this.fetchData();
      } else {
        console.error("Failed to change status:", data.message);
      }
    } catch (error) {
      console.error("Error changing status:", error);
    }
  };

  render() {
    const {
      DataList,
      length,
      pageNo,
      showPopup,
      showAddSubContestPopup,
      newName,
      newImage,
      isEditMode,
      editingItem,
    } = this.state;
    let i = (pageNo - 1) * Constant.perPage;
    let bodyData = "";

    if (DataList.length > 0) {
      bodyData = DataList.map((el) => {
        i++;

        return (
          <tr key={el._id}>
            <td>{i}</td>
            <td>{el.name}</td>
            <td>
              {el.image && (
                <img
                  src={el.image}
                  alt={el.name}
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />
              )}
            </td>
            <td>
              <button
                className={`contest-status-pill ${
                  el.status === 1 ? "is-active" : "is-inactive"
                }`}
                onClick={() => {
                  this.changeStatus(el._id, el.status);
                }}
              >
                {el.status === 1 ? "ACTIVE" : "INACTIVE"}
              </button>
            </td>
            <td className="actions-col">
              <button
                className="contest-icon-btn danger submission-action-btn"
                type="button"
                aria-label="Delete open mic"
                onClick={() => {
                  this.deleteItem(el._id);
                }}
              >
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{ fontSize: "13px" }}
                />
              </button>
              <button
                className="contest-icon-btn"
                type="button"
                aria-label="Edit open mic"
                onClick={() => {
                  this.handleEdit(el);
                }}
              >
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{ fontSize: "13px" }}
                />
              </button>
            </td>
            <td>
              <Link to={`/sub-openmics/${el._id}`} className="btn btn-info">
                Sub open mics
              </Link>
            </td>
          </tr>
        );
      });
    }

    let previous = 0;
    let next = 0;
    let customLength = 0;

    if (pageNo !== 0) {
      previous = pageNo - 1;
      next = pageNo + 1;
    }

    if (length !== 0) {
      customLength = length;
    }

    return (
      <div className="content-page contest-submissions-page contest-management-page open-sessions-page openmic-consistent-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Open Mic Management</h4>
                <p className="header-subtitle">
                  Manage open sessions and quickly jump to sub open mics.
                </p>
              </div>
              <div className="header-actions">
                <Link to="/add-contestlinks" className="btn openmic-link-btn">
                  Add Contest Links
                </Link>

                <button
                  type="button"
                  className="btn btn-primary btn-add-event contest-add-match"
                  onClick={this.togglePopup}
                >
                  + Add New Session
                </button>
              </div>
            </div>
          </div>

        {showPopup && (
          <div style={popupContainerStyle}>
            <div style={popupStyle}>
              <div style={popupInnerStyle}>
                <h4 style={{ textAlign: "center" }}>
                  {isEditMode ? "Edit Contest" : "Add Contest"}
                </h4>
                <input
                  type="text"
                  placeholder="Enter Name"
                  value={newName}
                  onChange={this.handleInputChange}
                  style={inputStyle}
                />
                <div style={{ marginBottom: "10px" }}>
                  <div
                    style={{
                      textAlign: "left",
                      width: "80%",
                      margin: "0 auto 6px",
                    }}
                  >
                    <strong>Main Image (Desktop)</strong>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleImageChange}
                    style={inputStyle}
                  />
                  {/* Image preview for new or existing image */}
                  {(newImage ||
                    (isEditMode && editingItem && editingItem.image)) && (
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={
                          newImage
                            ? URL.createObjectURL(newImage)
                            : editingItem && editingItem.image
                        }
                        alt="Preview"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "5px",
                        }}
                      />
                    </div>
                  )}
                </div>

                <div style={{ marginBottom: "10px" }}>
                  <div
                    style={{
                      textAlign: "left",
                      width: "80%",
                      margin: "10px auto 6px",
                    }}
                  >
                    <strong>Mobile Image</strong>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleMobileImageChange}
                    style={inputStyle}
                  />
                  {(this.state.newMobileImageFile ||
                    (isEditMode && editingItem && editingItem.mobileImage)) && (
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={
                          this.state.newMobileImageFile
                            ? URL.createObjectURL(this.state.newMobileImageFile)
                            : editingItem && editingItem.mobileImage
                        }
                        alt="Mobile Preview"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "5px",
                        }}
                      />
                    </div>
                  )}
                </div>
                <div style={buttonGroupStyle}>
                  <button
                    className="btn btn-info"
                    style={buttonStyle}
                    onClick={isEditMode ? this.editItem : this.addNewItem}
                  >
                    {isEditMode ? "Update" : "Add"}
                  </button>
                  <div style={{ width: "10px" }} />
                  <button
                    className="btn btn-danger"
                    style={buttonStyle}
                    onClick={this.togglePopup}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showAddSubContestPopup && <AddSubContest />}

        <div className="event-management-body">
          <div className="card contest-submissions-card contest-like-card">
            <div className="card-body">
              <div className="filter-section contest-submissions-filter-section">
                <div className="filter-group contest-submissions-filter">
                  <label>Status</label>
                  <select id="selectValue" className="form-control filter-select">
                    <option value="all">All</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
                <div className="filter-group contest-submissions-filter">
                  <p id="gen-message" className="message-feedback"></p>
                </div>
              </div>
              <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                <div
                  className="tab-pane show active"
                  id="buttons-table-preview"
                >
                  <table
                    id="complex-header-datatable"
                    className="table event-table contest-submissions-table contest-like-table"
                  >
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th className="namecol">Name</th>
                        <th>Image</th>
                        <th>Status</th>
                        <th className="actions-col">Action</th>
                        <th>Sub Open Mics</th>
                      </tr>
                    </thead>
                    <tbody>{bodyData}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}
export default withRouter(DataManagement);

const popupContainerStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 9999,
};

const popupStyle = {
  backgroundColor: "white",
  padding: "30px",
  borderRadius: "5px",
  width: "420px",
  maxWidth: "90%",
};

const popupInnerStyle = {
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const inputStyle = {
  display: "block",
  width: "80%",
  margin: "10px auto",
};

const buttonGroupStyle = {
  display: "flex",
  alignItems: "center",
  marginTop: "10px",
  justifyContent: "center",
};

const buttonStyle = {
  marginRight: "5px",
};
